
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/uploadData/ssw",
      function () {
        return require("private-next-pages/uploadData/ssw.tsx");
      }
    ]);
  